import { Link } from "react-router-dom";
import styles from "./NotFoundPage.module.css";

function NotFoundPage() {
  return (
    <div className={styles["not-found-container"]}>
      <div className={styles["not-found-content"]}>
        <div className={styles["not-found-icon"]}>404</div>
        <h1 className={styles["not-found-title"]}>Page Not Found</h1>
        <p className={styles["not-found-message"]}>
          The page you're looking for doesn't exist or has been moved.
        </p>
        <Link to="/" className={styles["not-found-button"]}>
          Go to Home
        </Link>
      </div>
    </div>
  );
}

export default NotFoundPage;

